import React from 'react';
import { Select } from 'antd';
import { COLOR_RAMPS } from '../../constants';
import { useLayerProperitesContext, ColorRamp } from '../../../../../context/LayerPropertiesContext';
import '../../LayerProperties.scss';
import './ColorRampSelect.scss';

interface ColorRampSelectProps {
  value?: ColorRamp;
  /** Context field to write to (legacy/context-bound usage). */
  onChangeName?: 'colorRamp' | 'selectedColourRamp';
  /** Controlled mode: when provided, the selected ramp is handed back here
   *  instead of being written to the LayerProperties context. */
  onChange?: (ramp: ColorRamp) => void;
  /** Render only the Select (no "COLOR RAMP" label/row wrapper). */
  bare?: boolean;
}

export const RampPreview = ({ rampId }: { rampId: string }) => (
  <div className={['lp-color-ramp-preview', `lp-color-ramp-preview--${rampId}`].join(' ')} />
);

const ColorRampSelect: React.FC<ColorRampSelectProps> = ({ value, onChangeName, onChange, bare }) => {
  const { setState } = useLayerProperitesContext();

  const handleChange = (id: string) => {
    const ramp = COLOR_RAMPS.find((r) => r.id === id);
    if (!ramp) return;
    if (onChange) {
      onChange(ramp);
    } else if (onChangeName) {
      setState((prev) => ({ ...prev, [onChangeName]: ramp }));
    }
  };

  const select = (
    <Select
      value={value?.id}
      onChange={handleChange}
      dropdownRender={(menu) => menu}
      className="lp-color-ramp-select"
      placeholder="Select a color ramp"
    >
      {COLOR_RAMPS.map((r) => (
        <Select.Option key={r.id} value={r.id} label={<RampPreview rampId={r.id} />}>
          <RampPreview rampId={r.id} />
        </Select.Option>
      ))}
    </Select>
  );

  if (bare) return select;

  return (
    <div className="lp-controls__row--no-margin">
      <span className="lp-controls__label--fixed">COLOR RAMP</span>
      {select}
    </div>
  );
};

export default ColorRampSelect;
